import { render, staticRenderFns } from "./OrderItemMenuUserPromoListItem.vue?vue&type=template&id=2a189b56&scoped=true&"
import script from "./OrderItemMenuUserPromoListItem.vue?vue&type=script&lang=js&"
export * from "./OrderItemMenuUserPromoListItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemMenuUserPromoListItem.vue?vue&type=style&index=0&id=2a189b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a189b56",
  null
  
)

export default component.exports